import { render } from "./StoryCommentsOverlayComposer.vue.js?vue&type=template&id=7150f0c5!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentsOverlayComposer.vue?vue&type=template&id=7150f0c5"
import script from "./StoryCommentsOverlayComposer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentsOverlayComposer.vue?vue&type=script&lang=js"
export * from "./StoryCommentsOverlayComposer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentsOverlayComposer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/story-comments/StoryCommentsOverlayComposer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7150f0c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7150f0c5', __exports__)) {
    api.reload('7150f0c5', __exports__)
  }
  
  module.hot.accept("./StoryCommentsOverlayComposer.vue.js?vue&type=template&id=7150f0c5!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentsOverlayComposer.vue?vue&type=template&id=7150f0c5", () => {
    api.rerender('7150f0c5', render)
  })

}


export default __exports__